import { render, staticRenderFns } from "./MentoringPackagesAdditionalInfo.vue?vue&type=template&id=2187094e&scoped=true&"
import script from "./MentoringPackagesAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./MentoringPackagesAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187094e",
  null
  
)

export default component.exports